import * as React from 'react';
import i18next from 'i18next';

import en from './data/en.json';
import nl from './data/nl.json';
import fr from './data/fr.json';
import it from './data/it.json';
import de from './data/de.json';

import getNavigatorLanguage from './utils/getBrowserLanguage';

const supportedLanguages: { [key: string]: any } = {
  en,
  nl,
  fr,
  it,
  de,
};
const deviceLanguage = getNavigatorLanguage();

const DEFAULT_LANGUAGE = 'en';

export const getCurrentLanguage = () => {
  if (!deviceLanguage) {
    return DEFAULT_LANGUAGE;
  }
  if (supportedLanguages[deviceLanguage]) {
    return deviceLanguage;
  }
  const languagekey = deviceLanguage.split('-')[0];
  if (supportedLanguages[languagekey]) {
    return languagekey;
  }
  return DEFAULT_LANGUAGE;
};

i18next.init({
  resources: {
    en: {
      translation: en,
    },
    nl: {
      translation: nl,
    },
    fr: {
      translation: fr,
    },
    it: {
      translation: it,
    },
    de: {
      translation: de,
    },
  },
  lng: getCurrentLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
});

export const t = (key: string, properties?: any): string => {
  let translation = i18next.t(key, properties) as string;
  translation = translation.replace(/\<\/?b\>/gi, '').replace(/\<\/?strong\>/gi, '');
  return translation;
};
export const tHtml = (key: string, properties?: any): any => {
  return <span dangerouslySetInnerHTML={{ __html: i18next.t(key, properties) }} />;
};
export default i18next;
